import React from 'react';
import { Container } from '@mui/material';
import { PlayerProfile } from './components/playerProfile.smart';
import { MobileHeader } from '../../components/mobileHeader/mobileHeader';
import { useQuerySync } from '../../state/queryParams/useQuerySync';
import { PlayerProfilePageQuery } from './playerProfilePage.queryParams.interface';
import { GlobalQueryParams } from '../../state/queryParams/queryParams.interface';
import { PlayerProfilePageQueryService } from './playerProfilePage.queryParam.service';
import { di } from '../../state/inversify.config';

export function PlayerProfilePage() {
  const playerProfileQueryService = di.get<PlayerProfilePageQueryService>(
    PlayerProfilePageQueryService,
  );
  useQuerySync<PlayerProfilePageQuery & GlobalQueryParams>(
    playerProfileQueryService,
  );

  return (
    <Container>
      <MobileHeader />
      <PlayerProfile />
    </Container>
  );
}
